import React, { useState } from 'react';
import { Modal } from 'react-bootstrap'
import './FloorPlanModal.scss'
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import {ImageModule} from "@Components/common/Image_Module";

const FloorPlanModal = (props) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let processedImages = JSON.stringify({});
    if (props?.Image_Transforms) {
        processedImages = props.Image_Transforms;
      }
    return (
        <>
        <li><a onClick={handleShow}><i class="icon-production"></i></a></li>
        {/* <span  className="zoom-icon"><i className="icon-zoom"></i></span> */}
            {/* <a >
                Floorplans
            </a> */}

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
                dialogClassName="floorplan-large-modal"
                className="floorplan_modal"
            >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body className="text-center">
                    <ImageModule ImageSrc={props.floorplanimg} attr={{ alt: '' }} ggfx_results={props.ggfx_results} imagename="property.images.floorplan" strapi_id={props.id} />
                    {/* <ImageTransform imagesources={props.floorplanimg} renderer="srcSet" imagename='property.images.floorplan'
                              attr={{ alt: "", className: 'img-fluid m-0 modal-img' }}
                              imagetransformresult={processedImages} id={props.id} >

                            </ImageTransform> */}
                        {/* <img src={props.floorplanimg} className="img-fluid m-0 modal-img" /> */}
                    </Modal.Body>
            </Modal>
        </>
    );
}

export default FloorPlanModal;